export function operacaoVazoesNaoAutorizadasInRequest(params = {}) {
  return {
    type: '@operacaovazaonaoautorizada/OPERACAOVAZOESNAOAUTORIZADAS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoVazaoNaoAutorizada(id) {
  return {
    type: '@operacaovazaonaoautorizada/FIND_OPERACAOVAZAONAOAUTORIZADA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaovazaonaoautorizada/FAILED_REQUEST',
  };
}

export function deleteOperacaoVazaoNaoAutorizada(id, params, query = {}) {
  return {
    type: '@operacaovazaonaoautorizada/DELETE_OPERACAOVAZAONAOAUTORIZADA',
    payload: { id, params, query },
  };
}

export function updateOperacaoVazaoNaoAutorizada(
  operacaovazaonaoautorizada,
  params
) {
  return {
    type: '@operacaovazaonaoautorizada/UPDATE_OPERACAOVAZAONAOAUTORIZADA',
    payload: { operacaovazaonaoautorizada, params },
  };
}

export function storeOperacaoVazaoNaoAutorizada(
  operacaovazaonaoautorizada,
  params
) {
  return {
    type: '@operacaovazaonaoautorizada/STORE_OPERACAOVAZAONAOAUTORIZADA',
    payload: { operacaovazaonaoautorizada, params },
  };
}

export function successInRequest(
  operacaovazoesnaoautorizadas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaovazaonaoautorizada/SUCCESS_IN_REQUEST',
    payload: {
      operacaovazoesnaoautorizadas,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaovazaonaoautorizada) {
  return {
    type: '@operacaovazaonaoautorizada/SUCCESS_REQUEST',
    payload: { operacaovazaonaoautorizada },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaovazaonaoautorizada/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function successRemoveForm(params) {
  return {
    type: '@operacaovazaonaoautorizada/SUCCESS_REMOVE_FORM',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaovazaonaoautorizada/RECORD_FILTERING',
    payload: { params },
  };
}

export function submitting(data) {
  return {
    type: '@operacaovazaonaoautorizada/SUBMITTING',
    payload: { data },
  };
}

export function deletarClienteOperacaoVazaoNaoAutorizada(data, params) {
  return {
    type:
      '@operacaovazaonaoautorizada/DELETE_OPERACAOVAZAONAOAUTORIZADA_CLIENTE',
    payload: { data, params },
  };
}
